import React from 'react';
import PropTypes from 'prop-types';

import { Input, Translate } from '../../common';

function MonthIndex({ index, updateIndex }) {
  const onChange = event => {
    const { value } = event.target;
    updateIndex(value);
  };

  const onBlur = event => {
    const { value } = event.target;
    if (value === '') {
      updateIndex(1);
    }
  };

  return (
    <table>
      <tbody>
        <tr>
          <td aria-label="Before">
            <Translate path="search.recurrence.monthDescription.before" />
          </td>
          <td aria-label="Button">
            <Input
              style={{ maxWidth: 65 }}
              type="number"
              value={index}
              onChange={onChange}
              onBlur={onBlur}
            />
          </td>
          <td aria-label="After">
            <Translate path="search.recurrence.monthDescription.after" />
          </td>
        </tr>
      </tbody>
    </table>
  );
}

MonthIndex.propTypes = {
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  updateIndex: PropTypes.func.isRequired
};

export default MonthIndex;
